export default {"src":"/_next/static/media/user-shared-fill.dc358b69.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};